import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import moment from "moment";
import "element-ui/lib/theme-chalk/index.css";
import Print from "vue-print-nb";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$moment = moment;

Vue.use(Print);
Vue.filter("formatDate", function(value) {
  return moment(value).format("YYYY-MM-DD");
});
Vue.filter("formatDateHM", function(value) {
  return moment(value).format("YYYY-MM-DD HH:mm");
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
